import type { ReactNode } from 'react';
import styled from 'styled-components';

import { useCommonGameSet } from '@sorare/core/src/set';

const Root = styled.div`
  isolation: isolate;
`;

const BackgroundElement = styled.div`
  position: fixed;
  isolation: isolate;
  inset: 0;
  z-index: -1;
`;

type Props = {
  children: ReactNode;
};
export const Background = ({ children }: Props) => {
  const { visual } = useCommonGameSet();
  return (
    <Root>
      <BackgroundElement style={visual.onboardingBackground} />
      {children}
    </Root>
  );
};
